export default __webpack_public_path__ + "static/media/stored-account.3a4d6531.png";